export default function AppException (message) {
  this.message = message
  this.name = 'AppException'
}
